<app-header title="{{'links-list.title' | transloco }}"></app-header>

<div class="flex mt-2">
    <app-sidebar optionMenu="5"></app-sidebar>

    <div class="bg-white rounded-2xl shadow-md mx-auto mt-8 w-3/4 h-3/4 flex flex-col px-10">

        <button [routerLink]="['/home-richmedia']" class="w-[79px] flex justify-between mt-8 items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 19L8 12L15 5" stroke="#038652" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
            <span class="font-bold text-[13px] text-[#666]">{{ 'Modules.Back' | transloco }}</span>
        </button>

        <div class="flex justify-between py-6 border-b">
            <h1 class="font-bold text-xl mt-4 md:text-2xl md:mt-1 mb-4">Formulario Campañas</h1>

            <button type="submit" (click)="submitForm()"
                class="items-center w-44 h-10 border rounded-md  bg-green-MainColor flex">
                <span class="text-white text-center font-semibold text-sm m-auto">{{ 'globals.save' | transloco}}</span>
            </button>
        </div>

        <form [formGroup]="formsAd" class="space-y-6 py-6">

            <div class="grid grid-cols-2 gap-6">
                <div class="flex items-center">
                    <label class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Nombre de la
                        campaña:</label>
                    <input type="text" formControlName="name" placeholder="Nombre de la campaña" class="flex-1 py-2 h-9 text-base rounded-xl pl-4 border border-dark-light 
                         focus:ring-1 focus:outline-none focus:border-transparent focus:ring-dark-light">
                </div>

                <div class="flex items-center">
                    <label class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Tipo:</label>
                    <select formControlName="type" class="flex-1 py-2 h-9 text-base rounded-xl pl-4 border border-dark-light 
                         focus:ring-1 focus:outline-none focus:border-transparent focus:ring-dark-light">
                        <option value="pulzo-ad-richmedia-interstitial">Interstitial</option>
                        <option value="pulzo-ad-richmedia-native">Native</option>
                        <option value="pulzo-ad-richmedia-float">Pauta Flotante</option>
                        <option value="pulzo-ad-richmedia-intext">Video Intext</option>
                    </select>
                </div>
            </div>

            <div class="grid grid-cols-2 gap-6">
                <div class="flex items-center">
                    <label class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Desplegar en:</label>
                    <select formControlName="activate_in" class="flex-1 py-2 h-9 text-base rounded-xl pl-4 border border-dark-light 
                         focus:ring-1 focus:outline-none focus:border-transparent focus:ring-dark-light">
                        <option value="sections">Solo secciones</option>
                        <option value="articles">Solo artículos</option>
                        <option value="both">Secciones y artículos</option>
                    </select>
                </div>

                <div class="flex items-center">
                    <label class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Dispositivo:</label>
                    <select formControlName="device" class="flex-1 py-2 h-9 text-base rounded-xl pl-4 border border-dark-light 
                         focus:ring-1 focus:outline-none focus:border-transparent focus:ring-dark-light">
                        <option value="desktop">Desktop</option>
                        <option value="mobile">Mobile</option>
                        <option value="any">Cualquiera</option>
                    </select>
                </div>
            </div>

            <div class="grid grid-cols-2 gap-6 pb-6 border-b">
                <div class="flex items-center">
                    <label class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Empieza:</label>
                    <input formControlName="start" type="datetime-local" class="flex-1 py-2 h-9 text-base rounded-xl pl-4 border border-dark-light 
                         focus:ring-1 focus:outline-none focus:border-transparent focus:ring-dark-light">
                </div>

                <div class="flex items-center">
                    <label class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Termina:</label>
                    <input formControlName="end" type="datetime-local" class="flex-1 py-2 h-9 text-base rounded-xl pl-4 border border-dark-light 
                         focus:ring-1 focus:outline-none focus:border-transparent focus:ring-dark-light">
                </div>
            </div>

            <div class="py-6">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <!-- Mostrar en -->
                    <div class="border border-blue-blue1 rounded-md">
                        <h3 class="w-full pt-3 bg-blue-blue1 h-12">
                            <span class="ml-4 text-blue-blue2">Mostrar en:</span>
                        </h3>

                        <div class="p-4 space-y-4">
                            <div class="flex items-center">
                                <label class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Secciones:</label>

                                <!-- Botón / input visual -->
                                <div class="relative flex-1">
                                    <button type="button"
                                        class="w-full min-h-[42px] border rounded-xl px-3 py-2 text-sm text-left bg-white 
                                            focus:outline-none focus:ring-2 focus:ring-blue-500 flex flex-wrap gap-2 cursor-text"
                                        (click)="dropdownOpenSections = !dropdownOpenSections">
                                        <span *ngIf="selectedSections.length === 0" class="text-gray-400">
                                            Selecciona una o varias secciones...
                                        </span>

                                        <span *ngFor="let secId of formsAd.value.sections; let i = index"
                                            class="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs flex items-center">
                                            {{ getSeccionNombre(secId) }}
                                            <button type="button" (click)="removeSeccion(i)"
                                                class="ml-1 text-blue-500 hover:text-blue-700">
                                                ✕
                                            </button>
                                        </span>
                                    </button>

                                    <!-- Dropdown -->
                                    <div *ngIf="dropdownOpenSections"
                                        class="absolute mt-1 w-full bg-white border rounded-xl shadow z-20 max-h-40 overflow-y-auto">
                                        <div *ngFor="let sec of secciones; trackBy: trackBySeccion"
                                            (click)="toggleSeccion(sec.key)"
                                            class="px-3 py-2 cursor-pointer hover:bg-gray-100 flex items-center">
                                            <input type="checkbox" [checked]="isSelected(sec.key)" class="mr-2"
                                                tabindex="-1" />
                                            {{ sec.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="flex items-center">
                                <label
                                    class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Artículos:</label>

                                <div class="relative flex-1">
                                    <div class="w-full min-h-[42px] border rounded-xl px-3 py-2 bg-white focus-within:ring-2 focus-within:ring-blue-500 flex flex-wrap items-center gap-2 cursor-text"
                                        (click)="focusArtInput()">
                                        <span *ngFor="let articulo of formsAd.value.articles; let i = index"
                                            class="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs flex items-center">
                                            {{ articulo.text }}
                                            <button type="button"
                                                (click)="removeArticulo(i); $event.stopPropagation()"
                                                class="ml-1 text-blue-500 hover:text-blue-700">✕</button>
                                        </span>
                                        <input #artInput type="text" placeholder="Id artículo. Ej: PP12345677"
                                            class="flex-1 min-w-[120px] border-none focus:ring-0 outline-none text-sm"
                                            (keydown)="onArticuloKeyDown($event)" (paste)="onArtPaste($event)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- No mostrar en -->
                    <div class="border border-pink-light rounded-md">
                        <h3 class="w-full pt-3 bg-pink-light h-12">
                            <span class="ml-4 text-pink-dark">No mostrar en:</span>
                        </h3>

                        <div class="p-4 space-y-4">
                            <div class="flex items-center">
                                <label
                                    class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Secciones:</label>

                                <!-- Botón / input visual -->
                                <div class="relative flex-1">
                                    <button type="button"
                                        class="w-full min-h-[42px] border rounded-xl px-3 py-2 text-sm text-left bg-white 
                                            focus:outline-none focus:ring-2 focus:ring-pink-400 flex flex-wrap gap-2 cursor-text"
                                        (click)="dropdownOpenSectionsOut = !dropdownOpenSectionsOut">
                                        <span *ngIf="selectedSectionsOut.length === 0" class="text-gray-400">
                                            Selecciona una o varias secciones...
                                        </span>

                                        <span *ngFor="let secId of selectedSectionsOut"
                                            class="bg-pink-100 text-pink-700 px-2 py-1 rounded-full text-xs flex items-center">
                                            {{ getSeccionNombre(secId) }}
                                            <button type="button" (click)="removeSeccionOut(secId)"
                                                class="ml-1 text-pink-500 hover:text-pink-700">
                                                ✕
                                            </button>
                                        </span>
                                    </button>

                                    <!-- Dropdown -->
                                    <div *ngIf="dropdownOpenSectionsOut"
                                        class="absolute mt-1 w-full bg-white border rounded-xl shadow z-30 max-h-40 overflow-y-auto">
                                        <div *ngFor="let sec of secciones; trackBy: trackBySeccion"
                                            (click)="toggleSeccionOut(sec.key)"
                                            class="px-3 py-2 cursor-pointer hover:bg-gray-100 flex items-center">
                                            <input type="checkbox" [checked]="isSelectedOut(sec.key)" class="mr-2"
                                                tabindex="-1" />
                                            {{ sec.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="flex items-center">
                                <label
                                    class="w-1/3 text-dark text-xs uppercase font-thin tracking-widest">Artículos:</label>

                                <div class="relative flex-1">
                                    <div class="w-full min-h-[42px] border rounded-xl px-3 py-2 bg-white focus-within:ring-2 focus-within:ring-blue-500 flex flex-wrap items-center gap-2 cursor-text"
                                        (click)="focusArtInputOut()">
                                        <span *ngFor="let articulo of formsAd.value.articlesOut; let i = index"
                                            class="bg-pink-100 text-pink-700 px-2 py-1 rounded-full text-xs flex items-center">
                                            {{ articulo.text }}
                                            <button type="button"
                                                (click)="removeArticuloOut(i); $event.stopPropagation()"
                                                class="ml-1 text-pink-500 hover:text-pink-700">✕</button>
                                        </span>
                                        <input #artInputOut type="text" placeholder="Id artículo. Ej: PP12345677"
                                            class="flex-1 min-w-[120px] border-none focus:ring-0 outline-none text-sm"
                                            (keydown)="onArticuloOutKeyDown($event)" (paste)="onArtOutPaste($event)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </form>

    </div>
</div>